import { writeLocalStorage } from "./guarded-local-storage"
import { REDIRECT_TARGET_KEY } from "./navigate-to-first-remaining-product"

export const redirectTo = (path: string, navigate: (route: string) => void): void => {
  writeLocalStorage(REDIRECT_TARGET_KEY, path)
  navigate(path)
}
